import { render, staticRenderFns } from "./_trainer.vue?vue&type=template&id=2b859b16&"
import script from "./_trainer.vue?vue&type=script&lang=js&"
export * from "./_trainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports